import clsx from 'clsx';

import { INSULATION_AREA_OPTIONS } from '../types/insulation';
import { useInsulationAreaSetting } from '../hooks/useInsulationAreaSetting';
import { ImageRaidoButton } from '../inputs';
import { TKEvent, InsuEnum } from '../types';

import { AnimateModal, ModalOpenProps } from '@/components/ui/modal';

/**
 * Polygon Area Correct Modal - launched from context menu!!!
 * Allows user to correct fields of an existing insulation polygon area.
 * Opens from the map context menu "Correct" action on polygon features.
 * @log created at 2026/06/05
 */
export const PolygonAreaCorrectModal = ({
  isOpen,
  isOnStage,
  lazyCloseHandler,
  itemId,
}: ModalOpenProps & { itemId: string }) => {
  const ias = useInsulationAreaSetting('polygon');

  const cancelHandler = () => lazyCloseHandler();

  const saveHandler = () => {
    const detail = {
      plgId: itemId,
      [InsuEnum.SC]: ias.serveCategory,
      [InsuEnum.IX]: ias.exposeType,
      [InsuEnum.AN]: ias.namePrefix,
    };
    document.dispatchEvent(
      new CustomEvent(TKEvent.POLYGON_PROP_CHANGED, { detail }),
    );
    lazyCloseHandler();
  };

  return (
    <AnimateModal
      isOpen={isOpen}
      isOnStage={isOnStage}
      lazyCloseHandler={cancelHandler}
      title="Correct Polygon Area"
      containerClass="w-auto max-h-full"
    >
      {/* Serve Category */}
      <h2 className="color-primary text-sm my-2">SERVE CATEGORY</h2>
      <div className="flex my-0 gap-6 w-80">
        <ImageRaidoButton
          label="DUCT"
          value="DUCT"
          name="category"
          selectedValue={ias.serveCategory}
          selectChangeHandler={ias.categoryChangeHandler}
        />
        <ImageRaidoButton
          label="PIPE"
          value="PIPE"
          name="category"
          selectedValue={ias.serveCategory}
          selectChangeHandler={ias.categoryChangeHandler}
        />
      </div>

      {/* Area Name */}
      <label className="color-primary text-sm block my-2">
        AREA NAME
        <input
          type="text"
          name="namePrefix"
          className="block w-full px-2 py-1.5 mt-1 text-sm frame-input"
          value={ias.namePrefix}
          onChange={ias.namePrefixChangeHandler}
          placeholder="e.g. ROOM, ROOM-1"
        />
      </label>

      {/* Insulation Area (Expose Type) */}
      <label className="color-primary text-sm block my-2">
        INSULATION AREA
        <select
          name="exposeType"
          className="block w-full px-2 py-1.5 mt-1 text-sm frame-input"
          value={ias.exposeType}
          onChange={ias.exposeTypeChangeHandler}
        >
          {INSULATION_AREA_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>

      {/* Button Row */}
      <div className="flex gap-x-10 justify-between mx-0 mt-4">
        <button
          className="btn-red-border color-red font-semibold flex-1 red-shadow"
          onClick={cancelHandler}
        >
          Cancel
        </button>
        <button
          className="btn-blue flex-1 leading-5 text-base shadow-md"
          onClick={saveHandler}
        >
          Save
        </button>
      </div>
    </AnimateModal>
  );
};
